import { render, staticRenderFns } from "./swiper-btn-wrap-primary.vue?vue&type=template&id=7ad74216&scoped=true&"
import script from "./swiper-btn-wrap-primary.vue?vue&type=script&lang=js&"
export * from "./swiper-btn-wrap-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad74216",
  null
  
)

export default component.exports